// extracted by mini-css-extract-plugin
export default {"toolbar":"EditorToolbar_toolbar__UM0Mz"};